import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const {
    email,
    password,
} = constantsData.forms.auth.login;

const {
    password: passwordFieldName,
    username: usernameFieldName,
} = formFieldNamesData;

export const loginFormData = [
    {
        label: email.label,
        name: usernameFieldName,
        type: InputTypeEnum.TEXT,
    },
    {
        label: password.label,
        name: passwordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
];
